// extracted by mini-css-extract-plugin
export default {"body":"warning-modal_body__-Fcss"};